module.exports = __webpack_public_path__ + "public/SiteIcons/googleSign.svg?d4c3d896";